import styled from "styled-components";
//import backgroundImage from "../../assets/bgimage.webp";
import backgroundImage from "../../assets/roundBackground.png";
import theme from "../../theme";

const PageWrapper = styled.div`
  min-height: 100vh;
  // max-height: 100vh;
  display: flex;
  flex-direction: column;
  // background: url(${backgroundImage}) no-repeat center center fixed;
  background: url(${backgroundImage}) no-repeat center center fixed;
  background-size: cover;
`;
const TopBar = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px 30px 0px 30px;
  color: white;
  font-weight: bold;

  img {
    width: clamp(120px, 10vw, 160px);
    height: auto;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 0px 20px;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  //   img {
  //     width: 100%;
  //     height: auto;
  //   }

  img {
    width: 100%;
    max-width: 800px; // ✅ Restrict image width
    height: auto;
    object-fit: contain;
  }

  @media (max-width: 1024px) {
    img {
      max-width: 400px; // ✅ Optionally smaller image on tablets
    }
  }

  @media (max-width: 768px) {
    img {
      max-width: 400px; // ✅ Optionally smaller image on mobile
    }
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Card = styled.div`
  background-color: ${theme.colors.background.paper};
  // background: #1a2032;
  border: 1px solid ${theme.colors.text.quinary};
  // border-radius: 20px;

  border-radius: 1.5rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: clamp(1.5rem, 3vw, 0.5rem);
  max-width: 500px;
`;

const HeaderContainer = styled.div`
  margin-bottom: 1rem;
`;

const Heading = styled.h1`
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: ${theme.colors.text.primary};
  margin-bottom: 0.5rem;
  font-family: "Inter", sans-serif;
`;

const SubText = styled.p`
  color: ${theme.colors.text.secondary};
  font-size: clamp(0.875rem, 2vw, 1rem);
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputWrapper = styled.div`
  width: 95%;
`;

const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin-bottom: 0.5rem;
  font-family: "Inter", sans-serif;
`;

const InputField = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  transition: border-color 0.2s;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  color: ${theme.colors.text.primary};

  &:focus {
    outline: none;
    border-color: ${theme.colors.border};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
`;

const CheckboxText = styled.p`
  font-size: 12px;
  color: ${theme.colors.text.secondary};
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Button = styled.button`
  width: 100%;
  height: 40px;
  background: ${theme.colors.gradient.themeGradient};
  color: white;
  font-weight: 600;
  padding: 8px;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
  font-family: "Inter", sans-serif;

  &:hover:not(:disabled) {
    background-color: ${theme.colors.primary};
    transform: scale(1.02);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    background-color: ${theme.colors.border};
    cursor: not-allowed;
    transform: none;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  color: ${theme.colors.text.secondary};
  font-size: 0.875rem;
  span {
    font-family: "Inter", sans-serif;
  }

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #e5e7eb;
  }

  &::before {
    margin-right: 0.75em;
  }

  &::after {
    margin-left: 0.75em;
  }
`;

const AlternativeAction = styled.div`
  text-align: center;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: ${theme.colors.text.secondary};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  // margin-bottom: 20px;
  span {
    font-family: "Inter", sans-serif;
  }
`;

const AlternativeButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.primary};
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
  font-family: "Inter", sans-serif;

  &:hover {
    color: ${theme.colors.primary};
    text-decoration: underline;
  }
`;

const SmallDivider = styled.div`
  width: 20%; // small width
  border-bottom: 1px solid #d1d5db; // light gray line
  margin: 0.5rem auto; // center horizontally and spacing
`;

const Span = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 12px;
`;

const SC = {
  PageWrapper,
  TopBar,
  MainContent,
  ImageWrapper,
  FormWrapper,
  Card,
  HeaderContainer,
  Heading,
  SubText,
  Form,
  InputWrapper,
  Label,
  InputField,
  CheckboxContainer,
  CheckboxItem,
  CheckboxText,
  Button,
  Divider,
  AlternativeAction,
  AlternativeButton,
  SmallDivider,
  Span,
};

export default SC;
